import * as Yup from 'yup';

export type TFormValues = {
  emailCode: string;
};

export const initialValues: TFormValues = {
  emailCode: '',
};

export const validationSchema = Yup.object().shape({
  emailCode: Yup.string().required('validation.required'),
});
